import { AfterViewInit, Component, inject, viewChild } from "@angular/core";
import { map } from "rxjs";
import { InvoiceEditModal } from "../../modals/invoice-modal/edit/invoice-edit-modal.component";
import { IFilterCategoryDef } from "../../shared/interfaces/IFilterDef";
import { LoadingService } from "../../shared/services/loading-overlay/loading-overlay.component";
import { SearchType } from "../../shared/services/search-storage.service";
import { GenericSearchPageComponent } from "../generic-search-page/generic-search-page.component";
import { filterDefinitions } from "./invoice-search-filters";
import { InvoiceSearchService } from "./invoice-search.service";
import { InvoiceSearchParameters } from "./types/InvoiceSearchParameters";
import { InvoiceSearchRow } from "./types/InvoiceSearchRow";
import { InvoiceSearchResultsGridComponent } from "./invoice-search-results-grid/invoice-search-results-grid.component";

@Component({
  selector: 'invoice-search',
  templateUrl: 'invoice-search.component.html',
  standalone: true,
  imports: [GenericSearchPageComponent, InvoiceSearchResultsGridComponent],
  providers: [LoadingService, InvoiceSearchService]
})
export class InvoiceSearchComponent implements AfterViewInit {
  private invoiceSearchService = inject(InvoiceSearchService);
  private loadingService = inject(LoadingService);
  private invoiceEditModal = inject(InvoiceEditModal);
  protected SearchPageComponent = viewChild.required<GenericSearchPageComponent<InvoiceSearchRow, InvoiceSearchParameters>>(GenericSearchPageComponent);

  protected filterCategories: IFilterCategoryDef<InvoiceSearchParameters>[] = filterDefinitions.filterCategories;
  protected searchHistoryType = SearchType.Invoices;
  protected searchFn = (params: InvoiceSearchParameters) => this.invoiceSearchService.Search(params);
  protected editFn = (row: InvoiceSearchRow) => this.invoiceEditModal.ShowModal({ InvoiceId: row.InvoiceId }).pipe(map((result) => result !== undefined));

  ngAfterViewInit() {
    const loadRef = this.loadingService.StartWaiting("Loading Options...");
    this.invoiceSearchService.GetInvoiceSearchFilters().subscribe((response) => {
      filterDefinitions.mapFiltersFromApi(response);
      this.SearchPageComponent().InitializeFilters();
      loadRef.Stop();
    });
  }
}
